import {Container, isMobile, Sprite, Text, TextStyle, Texture} from "pixi.js";
import {CANVAS} from "../constants/configs";
import {gsap} from "gsap";
import {getAmountWithCurrency} from "../utilites";
import {getStores} from './spin';
import {pixiComponents} from "../index";

export class TumbleWinBoard {
    container = new Container();
    bgSprite = new Sprite(Texture.from("./assets/tumbleWinBoardBg.webp"));
    amount = 0;
    displayAmount = 0;
    amountText = new Text("1000AMD", textStyle);
    multiplayer = 0;
    multiplayerText = new Text(" x20", textStyle);
    textContainer = new Container();
    isShown = false;


    constructor() {
        this.bgSprite.width = this.bgSprite.width * 0.8;
        this.container.pivot.set(this.bgSprite.width / 2, this.bgSprite.height * 0.85);
        this.textContainer.addChild(this.multiplayerText, this.amountText);
        this.container.addChild(this.bgSprite, this.textContainer);
        this.hide();
        this.initialization();

        //this.updateTextsPositions();
        // setTimeout(()=>this.hide(), 500);
        // // setTimeout(()=>this.show(), 3000);
        // // setTimeout(()=>this.multiplyAmount(), 4500);
        // setTimeout(()=>this.setAmount(520), 2000);
        // setTimeout(()=>this.setAmount(1860), 3500);
    }

    endTumbleSession() {
        this.hide();
        this.initialization();
    }

    initialization() {
        gsap.killTweensOf(this);
        this.amount = 0;
        this.displayAmount = 0;
        this.multiplayer = 0;
        this.amountText.text = "";
        this.multiplayerText.text = "";
    }

    hide() {
        this.isShown = false;
        gsap.to(this.container, {
            alpha: 0,
            overwrite: true,
        })
        gsap.to(pixiComponents.logo2, {
            alpha: 1,
            overwrite: true,
        })
    }

    show() {
        this.isShown = true;
        gsap.to(this.container, {
            alpha: 1,
            overwrite: true,
        })
        gsap.to(pixiComponents.logo2, {
            alpha: 0,
            overwrite: true,
        })
    }

    setAmount(newAmount) {
        if (!this.isShown) {
            this.show();
        }

        this.amount = newAmount;

        gsap.to(this, {
            displayAmount: newAmount,
            duration: 0.3,
            overwrite: true,
            onUpdate: () => {
                this.amountText.text = getAmountWithCurrency(this.displayAmount.toFixed(2), getStores().store.currency, false);
                this.updateTextsPositions();
            },
        })
    }

    setMultiplayer(multiplayer) {
        this.multiplayer = multiplayer;
        this.multiplayerText.text = ` x${multiplayer}`;
        gsap.to(this.multiplayerText.scale, {
            x: 1.05,
            y: 1.05,
            duration: 0.1,
            yoyo: true,
            repeat: 1,
        })
        this.updateTextsPositions();
    }

    addMultiplayer(multiplayer) {
        this.setMultiplayer(this.multiplayer + multiplayer);
    }

    pulseEffectOnTextContainer() {
        gsap.to(this.textContainer.scale, {
            x: 1.2,
            y: 1.2,
            yoyo: true,
            repeat: 1,
            duration: 0.25,
        })
    }

    async multiplyAmount() {
        if (!this.multiplayer) {
            return;
        }

        await gsap.to(this.multiplayerText, {
            x: this.amountText.width / 2,
            duration: 0.3,
        });

        this.multiplayerText.text = "";
        gsap.killTweensOf(this);
        this.amount *= this.multiplayer;
        this.displayAmount = this.amount;
        this.amountText.text = getAmountWithCurrency(this.amount.toFixed(2), getStores().store.currency, false);
        this.updateTextsPositions();
        this.pulseEffectOnTextContainer();

        await gsap.delayedCall(0.5, () => {
        })
    }

    updateTextsPositions() {
        this.multiplayerText.x = this.amountText.width;
        this.textContainer.pivot.x = (this.amountText.width + this.multiplayerText.width) / 2;
        this.textContainer.pivot.y = this.amountText.height / 2;
        this.textContainer.position.set(this.bgSprite.width / 2, this.bgSprite.height / 1.8);
    }


}

const textStyle = new TextStyle({
    fontFamily: 'BebasNeue',
    fontWeight: 500,
    fill: ['#ffffff', '#d2d2d2'],
    dropShadow: true,
    dropShadowColor: 'rgba(0,0,0,0.68)',
    dropShadowBlur: 4,
    dropShadowAngle: Math.PI / 4,
    dropShadowDistance: 2,
    fontSize: 39,
    wordWrapWidth: CANVAS.width * 1.8,
    align: 'center',
});